import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";
import { attempt } from "../../../../service/apiResult";

const apiService = new ApiService();

/** The four Ecosystem Integrator types with their configured post-login redirect URLs. */
export const getIntegratorTypes = async () =>
  attempt(async () => {
    // ApiService.get returns the full axios response.
    const response = await apiService.get(apiEndPoints.ecosytemIntegatorTypes);
    return response?.data ?? [];
  });

export const updateIntegratorTypeAppUrl = async (typeId, appUrl) =>
  attempt(() => apiService.update(`${apiEndPoints.ecosytemIntegatorTypes}/${typeId}`, { appUrl }));

/**
 * Every Initiative with the eK Link login URLs of its open and closed Initiative Based integrators:
 * `[{ initiativeId, name, initiativeType, active, countries, openAppUrl, closedAppUrl, openIntegrators, closedIntegrators }]`.
 */
export const getInitiativeRedirects = async () =>
  attempt(async () => {
    const response = await apiService.get(apiEndPoints.initiativeRedirects);
    return response?.data ?? [];
  });

/** Sets both URLs of the Initiative; an empty one is cleared. */
export const updateInitiativeRedirects = async (initiativeId, openAppUrl, closedAppUrl) =>
  attempt(() => apiService.update(`${apiEndPoints.initiativeRedirects}/${initiativeId}`, { openAppUrl, closedAppUrl }));
